import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import TermoTexto from "@/components/TermoTexto";
import { TERMO_VERSAO, TERMO_DATA } from "@/lib/termoConteudo";
import logoMark from "@/assets/logo-mark.png";

// Lote 87 — página pública com o Termo de Uso e Aviso de Privacidade (sem login).
export default function Termo() {
  return (
    <div className="min-h-screen bg-white px-5 py-10">
      <div className="max-w-2xl mx-auto space-y-6">
        <Link to="/" className="text-xs font-semibold text-stone-500 hover:text-stone-900 flex items-center gap-1 w-fit">
          <ArrowLeft className="w-3.5 h-3.5" strokeWidth={2} /> Voltar
        </Link>
        <div className="flex items-center gap-2">
          <img src={logoMark} alt="" className="w-9 h-9 rounded-md" />
          <span className="font-display text-xl font-bold"><span className="text-gold-600">IA</span>pauta</span>
        </div>
        <header>
          <h1 className="font-display text-2xl font-bold text-stone-900">Termo de Uso e Aviso de Privacidade</h1>
          <p className="text-xs text-stone-500 mt-1">Versão {TERMO_VERSAO} — {TERMO_DATA}</p>
        </header>
        <TermoTexto />
      </div>
    </div>
  );
}
